import type { Directive, DirectiveBinding } from 'vue';
import type { RoleCode } from '@/types';
import { hasAny } from '@/utils/permissions';
import { useAuthStore } from '@/stores/auth';

function check(el: HTMLElement, binding: DirectiveBinding<RoleCode[]>): void {
  const allowed = binding.value;
  if (!Array.isArray(allowed)) return;
  const auth = useAuthStore();
  if (!hasAny(auth.roles, allowed)) {
    el.style.display = 'none';
  } else {
    el.style.display = '';
  }
}

export const vPerm: Directive<HTMLElement, RoleCode[]> = {
  mounted: check,
  updated: check,
};
